import { render } from "./SearchResultNumbers.vue?vue&type=template&id=5b25c368&scoped=true&ts=true"
import script from "./SearchResultNumbers.vue?vue&type=script&lang=ts"
export * from "./SearchResultNumbers.vue?vue&type=script&lang=ts"

import "./SearchResultNumbers.vue?vue&type=style&index=0&id=5b25c368&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b25c368"]])

export default __exports__